import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const history = async () => axios.get(Routes.NOTE);

export const useHistory = () =>
  useQuery({
    queryKey: [Keys.HISTORY_QRY],
    queryFn: history,
  });
